import { isUuid } from './uuid.utils';

export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export const isValidInsightId = (id: string): boolean =>
  id !== NIL_UUID && isUuid(id);
